import { render } from "./Overview.vue?vue&type=template&id=f2224978&scoped=true"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"

import "./Overview.vue?vue&type=style&index=0&id=f2224978&scoped=true&lang=css"
import "./Overview.vue?vue&type=style&index=1&id=f2224978&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2224978"]])

export default __exports__